import PropTypes from 'prop-types'
import React from 'react'
import InputLabel from '../ui/InputLabel'
import Select from '../ui/Select'

// eslint-disable-next-line no-unused-vars
const PrecioRango = React.forwardRef(({ values, unidades, onChange, id }, ref) => {
  const { cantidad, idUnidadMedida, precio } = values

  return (
    <div className="row mg-7">
      <div className="col-12 col-md-5 col-lg-6 col-xl mb-2">
        <div className="row">
          <div className="col-4  col-sm-3 col-md-4">Cantidad</div>
          <div className="col">
            <InputLabel
              type="number"
              name="cantidad"
              value={cantidad}
              onChange={(e) => onChange(e, id)}
              classNameInput="publicacion-precio-mayorista"
              error="Completar Precio Mayorista Cantidad"
              onFocusSelected
            />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-7 col-lg-6 col-xl mb-2">
        <div className="row">
          <div className="col-4 col-sm-3 col-md-4">Unidad</div>
          <div className="col d-none d-md-block">
            <Select
              name="idUnidadMedida"
              value={idUnidadMedida}
              onChange={(e) => onChange(e, 'num')}
              className="select-publicacion unidad-publicacion"
              datos={unidades}
              optionMetaDatos={{ value: 'idUnidadMedida', text: 'nombre' }}
              optionPorDefecto={{ value: '0', text: 'Seleccionar' }}
              disabled={id > 0}
            />
          </div>
          <div className="col d-block d-md-none">
            <Select
              name="idUnidadMedida"
              value={idUnidadMedida}
              onChange={(e) => onChange(e, 'num')}
              className="select-publicacion-chico unidad-publicacion"
              datos={unidades}
              optionMetaDatos={{ value: 'idUnidadMedida', text: 'nombre' }}
              optionPorDefecto={{ value: '0', text: 'Seleccionar' }}
              disabled={id > 0}
            />
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-12 col-xl-4">
        <div className="row">
          <div className="col-4 col-sm-3 col-md-4 full-size">
            Precio Unitario &nbsp;
            <i className="fa fa-usd" aria-hidden="true" />
          </div>
          <div className="col">
            <InputLabel
              type="number"
              name="precio"
              value={precio}
              onChange={(e) => onChange(e, id)}
              classNameInput="publicacion-precio-mayorista"
              error="Completar Precio Mayorista Unitario"
              onFocusSelected
            />
          </div>
        </div>
      </div>
    </div>
  )
})

PrecioRango.displayName = 'PrecioRango'

PrecioRango.propTypes = {
  values: PropTypes.shape({
    cantidad: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    idUnidadMedida: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    precio: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
  }).isRequired,
  unidades: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
}

export default PrecioRango
